import { useMemo } from 'react'
import { Variant } from '~/@types/product'

type FallbackVariantsProps = {
  baseVariants: Variant[]
  baseDefaultVariant: Variant
  updatedVariants: Variant[]
  updatedDefaultVariant: Variant
  isUpdatedVariantsLoaded: boolean
  isVariantsEqual: boolean
}

export default function useFallbackVariants({
  baseVariants,
  baseDefaultVariant,
  updatedVariants,
  updatedDefaultVariant,
  isUpdatedVariantsLoaded,
  isVariantsEqual,
}: FallbackVariantsProps) {
  const memoizedValues = useMemo(() => {
    let variantsToUse = baseVariants
    let defaultVariantToUse = baseDefaultVariant

    // If I'm fully done loading variants
    if (isUpdatedVariantsLoaded) {
      // If the variants from the rest part and the updated ones are not deeply equal
      if (!isVariantsEqual) {
        // Then I'm attributing the variables to the updated ones I got from the server directly
        defaultVariantToUse = updatedDefaultVariant
        variantsToUse = updatedVariants
      }
    }

    return {
      isVariantsEqual,
      isUpdatedVariantsLoaded,
      variants: variantsToUse,
      defaultVariant: defaultVariantToUse,
    }
  }, [isUpdatedVariantsLoaded, isVariantsEqual])

  return {
    fallbackVariantValues: memoizedValues,
    compiledVariantProps: {
      ...(memoizedValues?.isVariantsEqual &&
      memoizedValues?.isUpdatedVariantsLoaded
        ? {}
        : {
            variants: memoizedValues?.variants,
            defaultVariant: memoizedValues?.defaultVariant,
          }),
    },
  }
}
